import { Component, Input, OnDestroy } from '@angular/core';
import { UserSearchType } from 'src/app/core/enums/user-search-type.enum';
import { Subject } from 'rxjs/internal/Subject';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { TranslateModule } from '@ngx-translate/core';
import { AccessComponent } from './access/access.component';

@Component({
    selector: 'app-ticket-access',
    templateUrl: './ticket-access.component.html',
    styleUrls: ['./ticket-access.component.scss'],
    imports: [TranslateModule, AccessComponent],
})
export class TicketAccessComponent implements OnDestroy {
    @Input() ticket: DetailedTicketDTO;

    isLoaded;
    userSearchTypeEnum = UserSearchType;

    private unsubscriber = new Subject<void>();

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
